export default __webpack_public_path__ + "7326d04fba6884899189a3cd0e27487a.glb";